var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ open: _vm.isOpen },attrs:{"id":"dropdown-overlay"},on:{"click":_vm.clickOverlay}},[_c('div',{ref:"overlayOptions",staticClass:"options overlay-options",style:(_vm.overlayRect)},[_c('div',{pre:true,attrs:{"class":"overlay-options-inner"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }